// extracted by mini-css-extract-plugin
export default {"root":"EmulatorWin98_root__3EVVX","TaskBar":"EmulatorWin98_TaskBar__JqYwM"};